import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { errorToast, successToast } from "../../../components/toast";
import { useDeleteEmailFooter } from "../../../services/usersApi";

export const DeleteEmailFooterButton = (props) => {
    const { emailFooterId, onSuccess } = props;
    const { t } = useTranslation();

    const { mutate: deleteEmailFooter } = useDeleteEmailFooter({
        onSuccess: () => {
            onSuccess?.();
            successToast(t("sellers.EmailFooterDeleteButton.deleteSuccess"));
        },
        onError: () => {
            errorToast(t("sellers.EmailFooterDeleteButton.deleteError"));
        },
    });

    return (
        <IconButton onClick={() => deleteEmailFooter({ emailFooterId })}>
            <DeleteIcon />
        </IconButton>
    );
};
